import bindRemoveEmptyFieldsOnFormSubmit from '../bindRemoveEmptyFieldsOnFormSubmit';
import { init as initAccountActions, toggleMenu as toggleAccountActionsMenu } from '../components/AccountActions';
import '../components/ReuploadField';
import { contentShowHide as initContentShowHide } from '../components/SaleAd';
import '../elements/BannerCarouselElement';
import '../elements/CategoryCarouselElement';
import '../elements/SaleAdCarouselElement';

jQuery(($) => {
	initContentShowHide();
	const isLoggedIn = $('body').hasClass('loggedIn');
	$('html').removeClass('no-js').addClass('js');

	$('form.userform').each(function (this: HTMLElement) {
		const params = new URLSearchParams(window.location.search);
		const agent = params.get('agent');
		const image = params.get('image');
		const url = 'http://www.farmclearingsales.com.au';

		if (image && agent) {
			$(this).prepend(`<div class="agentImage"><img src="${url}${image}" /><h3>${decodeURI(agent)}</h3></div>`);
		}
	});

	// Hides the back to top button unless the user scrolls a certain distance
	const returnTopEl = $('#BackToTop');

	$(document).on('scroll', () => {
		if (window.scrollY > 900 && returnTopEl.hasClass('-hidden')) {
			returnTopEl.removeClass(' -hidden');
		} else if (window.scrollY < 900 && returnTopEl.hasClass('-hidden') != true) {
			returnTopEl.addClass(' -hidden');
		}
	});

	bindRemoveEmptyFieldsOnFormSubmit();

	initAccountActions($);

	$('.postAnAdButton').on('click', (e) => {
		if (!isLoggedIn) {
			e.preventDefault();
			e.stopPropagation();
			toggleAccountActionsMenu(true);
		}
	});
});
